export const composeLiteral = (protocol, payloadName) => (protocol ? `${protocol}:${payloadName}` : payloadName);
export const payloadFactory = new Map();
export function registerPayloadType(protocol, name, layout) {
    const payloadLiteral = composeLiteral(protocol, name);
    if (payloadFactory.has(payloadLiteral))
        throw new Error(`Payload type ${payloadLiteral} already registered`);
    payloadFactory.set(payloadLiteral, layout);
}
export function registerPayloadTypes(protocol, payloads) {
    for (const [name, layout] of payloads)
        registerPayloadType(protocol, name, layout);
}
//# sourceMappingURL=registration.js.map